"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9263],{

/***/ 79895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),

/***/ 82746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js + 2 modules
var Accordion = __webpack_require__(27959);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FiberManualRecord.js
var FiberManualRecord = __webpack_require__(93837);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/eytestimoniallogo.png
/* harmony default export */ var eytestimoniallogo = ({"src":"/_next/static/media/eytestimoniallogo.243068f9.png","height":256,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEVMaXHPwwwiJyIVGyP/6AAJEiUfHx92cxUYISGOhBH/9wAPFSTNII/fAAAADHRSTlMAChpdLm4YUjVLRZj8bGYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgYGBg5GJhAAEmdk5GMIOZmxVMMzBxsDEwMAAABPIARhk/dyQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/sumuptestimoniallogo.png
/* harmony default export */ var sumuptestimoniallogo = ({"src":"/_next/static/media/sumuptestimoniallogo.67b4e899.png","height":242,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAACHRSTlM5sCdHaV2kwxcmCw0AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BkY2FgYGZmYmBnZGFgZmBlAgABhwAqMVO/dwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/taxfixtestimoniallogo.png
/* harmony default export */ var taxfixtestimoniallogo = ({"src":"/_next/static/media/taxfixtestimoniallogo.bebb6f0b.png","height":315,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUoykQyzFEyx1AyylA0yE8xyVA00FIxxk8CmbqJAAAACHRSTlMEEkY2KI2Bbal8zgYAAAAJcEhZcwAAFxIAABcSAWef0lIAAAAfSURBVHicBcGHAQAwDMMgeaX/f1xAghrI9u5WZCe1PgNDAERDYZWDAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Testimonials.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  margin: 0 !important;\n  .MuiAccordion-root:before {\n    display: none;\n  }\n\n  &:before {\n    opacity: 0 !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  &:before {\n    opacity: 0 !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  &:hover {\n    fill: #3c4340;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n  text-align: left;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fill-available;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  padding: ",
        "px;\n  ",
        " {\n    padding: 0;\n    padding-right: 40px;\n    width: 489px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Poppins;\n  font-size: 14px;\n  line-height: 23.52px;\n  font-weight: 400;\n  text-align: left;\n  ",
        " {\n    font-size: 20px;\n    line-height: 33.6px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: system-ui;\n  font-size: 16px;\n  line-height: 27.6px;\n  font-weight: 700;\n  text-align: left;\n  ",
        " {\n    font-size: 29px;\n    line-height: 50.03px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Poppins;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n  text-align: left;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Poppins;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n  text-align: left;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border-radius: 22px;\n  padding: ",
        "px;\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 26.88px;\n    text-align: left;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  gap: ",
        "px;\n  border-radius: 22px;\n  border: 2px solid #9cba6c;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fill-available;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  padding: ",
        "px;\n  ",
        " {\n    width: fill-available;\n    max-width: 568px;\n    padding: 0;\n    flex-direction: column;\n    padding-left: 80px;\n    margin: 85px auto;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  flex: 1 1 0px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 0px;\n  display: flex;\n  ",
        " {\n    background: #f8f8f8;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex !important;\n  margin: 40px 0;\n  flex-direction: column;\n  box-shadow: 0 4px 40px rgba(62, 41, 29, 0.08);\n  margin: auto;\n  width: 343px !important;\n  min-height: 433px !important;\n  ",
        " {\n    margin: 0;\n    flex-direction: row;\n    width: auto !important;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-initialized .slick-slide {\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 46px !important;\n  height: 46px !important;\n  width: 46px !important;\n  color: #e3e4e4 !important;\n  margin-left: 110px;\n  z-index: 1;\n  &:hover {\n    color: #3c4340;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 46px !important;\n  height: 46px !important;\n  width: 46px !important;\n  transform: translateY(-50%) rotate(180deg) !important;\n  color: #3c4340 !important;\n  margin-right: 110px;\n  z-index: 1;\n  &:hover {\n    color: #3c4340 !important;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  text-align: center;\n  font-size: 20px;\n  line-height: 34.5px;\n  padding: ",
        ";\n  ",
        " {\n    padding: 0;\n    font-size: 36px;\n    line-height: 62.1px;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}

















function Testimonials() {
    var ref = (0,react.useState)(null), _sliderRef = ref[0], setSliderRef = ref[1];
    var ref1 = (0,react.useState)(0), currentTab = ref1[0], setCurrentTab = ref1[1];
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var slides = [
        {
            logo: {
                src: taxfixtestimoniallogo,
                width: 164,
                height: 67
            },
            left: {
                headline: t("testimonials.slide1.left.headline"),
                review: t("testimonials.slide1.left.review"),
                name: t("testimonials.slide1.left.name"),
                title: t("testimonials.slide1.left.title")
            },
            right: {
                top: {
                    heading: t("testimonials.slide1.right.top.heading"),
                    subtitle: t("testimonials.slide1.right.top.subtitle")
                },
                bottom: {
                    heading: t("testimonials.slide1.right.bottom.heading"),
                    subtitle1: t("testimonials.slide1.right.bottom.subtitle1"),
                    subtitle2: t("testimonials.slide1.right.bottom.subtitle2")
                }
            }
        },
        {
            logo: {
                src: sumuptestimoniallogo,
                width: 151,
                height: 45
            },
            left: {
                headline: t("testimonials.slide2.left.headline"),
                review: t("testimonials.slide2.left.review"),
                name: t("testimonials.slide2.left.name"),
                title: t("testimonials.slide2.left.title")
            },
            right: {
                top: {
                    heading: t("testimonials.slide2.right.top.heading"),
                    subtitle: t("testimonials.slide2.right.top.subtitle")
                },
                bottom: {
                    heading: t("testimonials.slide2.right.bottom.heading"),
                    subtitle1: t("testimonials.slide2.right.bottom.subtitle1"),
                    subtitle2: t("testimonials.slide2.right.bottom.subtitle2")
                }
            }
        },
        {
            logo: {
                src: eytestimoniallogo,
                width: 141,
                height: 67
            },
            left: {
                headline: t("testimonials.slide3.left.headline"),
                review: t("testimonials.slide3.left.review"),
                name: t("testimonials.slide3.left.name"),
                title: t("testimonials.slide3.left.title")
            },
            right: {
                top: {
                    heading: t("testimonials.slide3.right.top.heading"),
                    subtitle: t("testimonials.slide3.right.top.subtitle")
                },
                bottom: {
                    heading: t("testimonials.slide3.right.bottom.heading"),
                    subtitle1: t("testimonials.slide3.right.bottom.subtitle1"),
                    subtitle2: t("testimonials.slide3.right.bottom.subtitle2")
                }
            }
        }, 
    ];
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: function(oldIndex, newIndex) {
            return setCurrentTab(newIndex);
        },
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackIcon, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextIcon, {}),
        arrows: !mobile,
        customPaging: function(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-dot ".concat(currentTab === i ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorIcon, {
                    style: {
                        fill: currentTab === i ? "#3C4340" : "#E3E4E4"
                    }
                })
            });
        },
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    bottom: mobile ? "-40px" : "-40px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        margin: "0px",
                        padding: 0
                    },
                    children: [
                        " ",
                        dots,
                        " "
                    ]
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Erstklassige Unternehmen vertrauen uns seit Jahren"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: function(slider) {
                        return setSliderRef(slider);
                    }
                }, settings), {
                    children: slides.map(function(card, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Slide, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialLeftBox, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBox, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: card.logo.src,
                                                    width: (ref = card.logo) === null || ref === void 0 ? void 0 : ref.width,
                                                    height: (ref1 = card.logo) === null || ref1 === void 0 ? void 0 : ref1.height,
                                                    quality: 100
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                                children: card.left.headline
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, {
                                                children: card.left.review
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactName, {
                                                        children: card.left.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTitle, {
                                                        children: card.left.title
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                mobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopAccordion, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccordionSummary, {
                                                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                            children: card.right.top.heading
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccordionDetails, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        children: card.right.top.subtitle
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomAccordion, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccordionSummary, {
                                                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                            children: card.right.bottom.heading
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccordionDetails, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            children: card.right.bottom.subtitle1
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            children: card.right.bottom.subtitle2
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialRightBox, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightCard, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopCard, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                            children: card.right.top.heading
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        children: card.right.top.subtitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomCard, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                            children: card.right.bottom.heading
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        children: card.right.bottom.subtitle1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        children: card.right.bottom.subtitle2
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                }))
            })
        ]
    });
}
var TopAccordion = (0,styled_components_browser_esm/* default */.ZP)(Accordion/* default */.Z)(_templateObject());
var BottomAccordion = (0,styled_components_browser_esm/* default */.ZP)(Accordion/* default */.Z)(_templateObject1());
var ImageBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
var StyledAccordionSummary = (0,styled_components_browser_esm/* default */.ZP)(AccordionSummary/* default */.Z)(_templateObject3(), function(props) {
    return props.theme.spacing(0, 2);
});
var StyledAccordionDetails = (0,styled_components_browser_esm/* default */.ZP)(AccordionDetails/* default */.Z)(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var IndicatorIcon = (0,styled_components_browser_esm/* default */.ZP)(FiberManualRecord/* default */.Z)(_templateObject5());
var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject6());
var RightCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Review = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ContactName = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject10());
var ContactTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject11());
var TopCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Head = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13());
var BottomCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var TestimonialLeftBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject16());
var TestimonialRightBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Slide = styled_components_browser_esm/* default.div */.ZP.div(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var SliderWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject19());
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject20());
var BackIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowBackIos/* default */.Z)(_templateObject21());
var NextIcon = (0,styled_components_browser_esm/* default */.ZP)(ArrowBackIos/* default */.Z)(_templateObject22());
var Title = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject23(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});


/***/ })

}]);